import { render, staticRenderFns } from "./Locality.vue?vue&type=template&id=069ee5ff&"
import script from "./Locality.vue?vue&type=script&lang=ts&"
export * from "./Locality.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports